let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("23Unp")).then(() => parcelRequire('kaBqe'));